import React, { useEffect, useState } from "react";
import MainBody from "../../../component/MainBody";
import AddUpdateSF from "./AddUpdateSF";
import { useNavigate, useParams } from "react-router-dom";
import httpRequest from "../../../utils/Http";
import { useSelector } from "react-redux";
import { ONLY_RM_ASM_ACTION_PERMISSION } from "../../../constant/action_permission";

const AddUpdateServiceCenter = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.authReducer.currentUser);
  const [sfdetails, SetSfDetails] = useState({});
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(Boolean(id));
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    let isMounted = true;

    (async () => {
      if (!user || Object.keys(user).length === 0) return;

      if (!id) {
        SetSfDetails({});
        setLoadError("");
        setIsLoading(false);
        return;
      }

      if (!ONLY_RM_ASM_ACTION_PERMISSION.includes(user.role_id) && Number(id) !== Number(user.entity_id)) {
        navigate("/");
        return;
      }

      setIsLoading(true);
      setLoadError("");
      SetSfDetails({});

      const listdata = await httpRequest(`getsfdetails?id=${id}`, {}, "GET");
      const details = listdata?.data?.rows?.[0];
      if (!isMounted) return;

      if (listdata.status === true && details) {
        SetSfDetails(details);
      } else {
        setLoadError(listdata.message || "Service center was not found.");
      }
      setIsLoading(false);
    })();

    return () => {
      isMounted = false;
    };
  }, [id, navigate, user]);

  if (id && isLoading) {
    return <MainBody breadcrumbTitle="Update Service Center" breadcrumbSubTitle="" navButton="" title="" component={<div className="p-3">Loading service center...</div>} />;
  }

  if (id && (loadError || Object.keys(sfdetails).length === 0)) {
    return <MainBody breadcrumbTitle="Invalid Url" breadcrumbSubTitle="" navButton="" title="" component={<div className="p-3">{loadError || "Service center was not found."}</div>} />;
  }

  return (
    <MainBody
      breadcrumbTitle={id ? "Update Service Center" : "Add Service Center"}
      breadcrumbSubTitle=""
      navButton=""
      title=""
      component={<AddUpdateSF sfdetails={sfdetails} SetSfDetails={SetSfDetails} roleId={user?.role_id} />}
    />
  );
};

export default AddUpdateServiceCenter;
